import { APIException } from "@services/api";

export const getTranslationKeyFromAPIError = (
  prefix: string,
  error: APIException
): string => {
  const errorMessage = error.message.split(".")[0];
  return `${prefix}.${errorMessage}`;
};
